'use client';

import { useQuery } from '@tanstack/react-query';
import { allProjects } from 'enteties/project/api';
import { ProjectCard } from 'enteties/project/ui/project-card';
import { useSidebarEffect } from 'shared/hooks/useSidebarEffect';
import { FirstProject } from 'widgets/projects-list/ui/first-project';
import { InstanceController } from 'widgets/instance-controller';
import { useOnError } from 'shared/hooks/useOnError';
import { LoadingServicesItems } from 'shared/ui/loading/loading-services-items';
export const AppList = () => {
  const {
    data: projects,
    isError,
    error,
    isLoading
  } = useQuery({
    ...allProjects.getAllProjectsQueryOptions(),
    select: data => data.services.filter(project => project.serviceType === 'compute')
  });
  useOnError({
    isError,
    description: error?.message
  });
  useSidebarEffect(true);
  if (isLoading) return <LoadingServicesItems />;
  if (!projects?.length) return <FirstProject text="Создайте первое приложение!" serviceType="app" />;
  return <div className="flex flex-col gap-2" data-sentry-component="AppList" data-sentry-source-file="app-list.tsx">
      {projects.map(project => <ProjectCard projectType="applications" key={project.id} project={project}>
          <ProjectCard.ResourceStatus />
          <ProjectCard.Instances instanceController={<InstanceController slug={project.slug} project={project} version="center" />} />
        </ProjectCard>)}
    </div>;
};